"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _spinner = require("../spinner/spinner");
var _IconButton = _interopRequireDefault(require("../button/IconButton"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Alert = require("../alert/Alert");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var TextInput = /*#__PURE__*/function (_React$Component) {
  _inherits(TextInput, _React$Component);
  var _super = _createSuper(TextInput);
  function TextInput(props) {
    var _this;
    _classCallCheck(this, TextInput);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onSearchKeyPressed", function (event) {
      var onSearchIconClick = _this.props.onSearchIconClick;
      if (event.keyCode === 13) onSearchIconClick && onSearchIconClick(event);
    });
    _defineProperty(_assertThisInitialized(_this), "onCrossKeyPressed", function (event) {
      var onCrossIconClick = _this.props.onCrossIconClick;
      if (event.keyCode === 13) onCrossIconClick && onCrossIconClick(event);
    });
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.onIconClick = _this.onIconClick.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.state = {
      value: "",
      showDescription: true,
      labelUp: false,
      labelFocus: '',
      isDown: true
    };
    return _this;
  }
  _createClass(TextInput, [{
    key: "onFocus",
    value: function onFocus(event) {
      if (this.props.onFocus) {
        this.props.onFocus(event);
      }
      var labelHeight = 20;
      if (event.target && event.target.nextSibling) {
        labelHeight = event.target.nextSibling.clientHeight;
      }
      this.setState({
        labelFocus: labelHeight > 20 ? 'text-input-large-focus' : 'text-input-small-focus',
        showDescription: true,
        isDown: !this.state.isDown
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur(event) {
      if (this.props.onBlur) {
        this.props.onBlur(event);
      }
      var labelHeight = 20;
      if (event.target && event.target.nextSibling) {
        labelHeight = event.target.nextSibling.clientHeight;
      }
      var labelFocus;
      if (event.target.value && event.target.value.length > 0) {
        labelFocus = labelHeight > 20 ? 'text-input-large-focus' : 'text-input-small-focus';
      } else {
        labelFocus = labelHeight > 20 ? 'text-input-large' : 'text-input-small';
      }
      this.setState({
        // showDescription: false,
        labelUp: event.target.value && event.target.value.length > 0,
        labelFocus: labelFocus,
        isDown: !this.state.isDown
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      if (this.props.onChange) {
        this.props.onChange(event);
      }
      ;
    }
  }, {
    key: "onIconClick",
    value: function onIconClick(event) {
      if (this.props.onIconClick) {
        this.props.onIconClick(event);
      }
    }
  }, {
    key: "getAssistiveText",
    value: function getAssistiveText() {
      var content;
      if (this.props.errors && this.props.errors[0] != '') {
        content = this.props.errors.map(function (err, index) {
          return /*#__PURE__*/_react.default.createElement(_Alert.Alert, {
            key: "err-".concat(index),
            name: "alert-inline-warning",
            icon: "icon-system-alert-small",
            label: err,
            labelClass: "error-message body14-light"
          });
        });
      } else if (this.props.successMessage) {
        content = /*#__PURE__*/_react.default.createElement(_Alert.Alert, {
          name: "alert-inline-success",
          icon: "icon-system-tick-copy",
          label: this.props.successMessage,
          labelClass: "success-message body14-light"
        });
      } else if (this.props.assistiveText && this.state.showDescription && this.props.variant !== 'advance') {
        content = /*#__PURE__*/_react.default.createElement(_Alert.Alert, {
          name: "alert-inline-info-tick",
          label: this.props.assistiveText,
          labelClass: "body14-light"
        });
      } else {
        content = "";
      }
      return content ? /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-text-input-assistive-text"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "subtext-placeholder",
        id: "".concat(this.props.id, "--help-text")
      }, content)) : null;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var labelElems = document.getElementsByClassName('text-input-small');
      for (var elem in labelElems) {
        if (labelElems[elem] && labelElems[elem].clientHeight > 20) {
          labelElems[elem].classList.add('text-input-large');
          labelElems[elem].classList.remove('text-input-small');
        }
      }
      labelElems = document.getElementsByClassName('text-input-small-focus');
      for (var _elem in labelElems) {
        if (labelElems[_elem] && labelElems[_elem].clientHeight > 20) {
          labelElems[_elem].classList.add('text-input-large-focus');
          labelElems[_elem].classList.remove('text-input-small-focus');
        }
      }
    }
  }, {
    key: "getInputClass",
    value: function getInputClass(propClass) {
      var inputClass = 'tl-text-input-box ';
      if (this.props.variant === 'advance' && this.props.errors && this.props.errors[0] !== '') {
        inputClass += '-error ';
      } else if (this.props.errors && this.props.errors[0] != '') {
        inputClass += 'input-error ';
      } else if (this.props.successMessage) {
        inputClass += 'input-success ';
      }
      if (propClass) {
        inputClass += propClass;
      }
      return inputClass;
    }
  }, {
    key: "renderInputBox",
    value: function renderInputBox() {
      var labelClass, labelClassFocus;
      var _this$props = this.props,
        searchIcon = _this$props.searchIcon,
        loading = _this$props.loading,
        crossIcon = _this$props.crossIcon,
        highlightIcon = _this$props.highlightIcon,
        onCrossIconClick = _this$props.onCrossIconClick,
        onSearchIconClick = _this$props.onSearchIconClick,
        variant = _this$props.variant,
        label = _this$props.label,
        assistiveText = _this$props.assistiveText,
        ariaAttributes = _this$props.ariaAttributes,
        resetButtonAria = _this$props.resetButtonAria,
        searchButtonAria = _this$props.searchButtonAria;
      var customAriaAttributes = _objectSpread({}, ariaAttributes);
      if (assistiveText) {
        customAriaAttributes = _objectSpread(_objectSpread({}, customAriaAttributes), {}, {
          "aria-describedby": "".concat(this.props.id, "--help-text")
        });
      }
      labelClass = 'heading16';
      if (this.state.labelFocus === '' || this.props.value || this.props.placeholder) {
        if (this.props.value && this.props.value.length > 0 || this.props.placeholder) {
          labelClassFocus = 'text-input-small-focus';
        } else {
          labelClassFocus = 'text-input-small';
        }
      } else {
        labelClassFocus = this.state.labelFocus;
      }
      var baseIconWidth = 24;
      var offset = 8;
      var labelUp = labelClass + ' ' + labelClassFocus;
      var inputClass = this.getInputClass(this.props.className);
      var labelId = this.props.id ? this.props.id + "-label" : this.props.name + '-label';
      var icons = [];
      if (loading) {
        icons.push( /*#__PURE__*/_react.default.createElement("div", {
          key: icons.length + 1,
          className: "text-spinner"
        }, /*#__PURE__*/_react.default.createElement(_spinner.Spinner, {
          size: "tl-spinner-small"
        })));
      }
      if (crossIcon && !loading) {
        icons.push( /*#__PURE__*/_react.default.createElement(_IconButton.default, _extends({
          key: icons.length + 1,
          "aria-label": "reset search keyword",
          outline: false,
          able: true,
          active: false,
          onClick: onCrossIconClick,
          events: {
            onKeyDown: this.onCrossKeyPressed
          },
          className: "".concat(searchIcon ? 'icon-system-ui-cross  icon-up-down tl-input-cross-icon' : 'icon-system-ui-cross icon-up-down tl-input-single-cross-icon'),
          icon: "Close"
        }, resetButtonAria)));
      }
      if (searchIcon && !loading) {
        icons.push( /*#__PURE__*/_react.default.createElement(_IconButton.default, _extends({
          key: icons.length + 1,
          outline: false,
          active: false,
          onClick: onSearchIconClick,
          events: {
            onKeyDown: this.onSearchKeyPressed
          },
          able: true,
          icon: 'Search',
          "aria-label": "Initiate Search",
          className: "".concat(!highlightIcon ? 'icon-system-ui-search  icon-up-down tl-input-search-icon' : 'icon-system-ui-search  icon-up-down tl-input-search-icon highlight-icon')
        }, searchButtonAria)));
      }
      if (this.props.isDropdown) {
        icons.push(this.state.isDown ? /*#__PURE__*/_react.default.createElement("svg", {
          key: icons.length + 1,
          role: "img",
          "aria-hidden": "true",
          focusable: false,
          onClick: this.props.onDownIconClick,
          className: "icon-system-ui-down-arrow svg-default-style icon-up-down"
        }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: "icon-system-ui-down-arrow"
        })) : /*#__PURE__*/_react.default.createElement("svg", {
          key: icons.length + 1,
          role: "img",
          "aria-hidden": "true",
          focusable: false,
          className: "icon-system-ui-up-arrow svg-default-style icon-up-down"
        }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: "icon-system-ui-up-arrow"
        })));
      }
      if (this.props.iconOnRightSide && this.props.iconName) {
        icons.push( /*#__PURE__*/_react.default.createElement("svg", {
          key: icons.length + 1,
          role: "img",
          "aria-hidden": "true",
          focusable: false,
          className: "icon-system-ui-up-arrow svg-default-style icon-up-down tl-input-right-icon",
          onClick: this.onIconClick
        }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: this.props.iconName
        })));
      }
      var inputStyle = {};
      if (icons.length) {
        inputStyle = {
          paddingRight: icons.length * baseIconWidth + offset * 2
        };
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-input"
      }, variant === 'advance' && label ? /*#__PURE__*/_react.default.createElement("label", {
        id: labelId,
        className: 'tl-inputV1-label heading16',
        form: this.props.parent,
        htmlFor: this.props.id
      }, label) : '', variant === 'advance' && assistiveText ? /*#__PURE__*/_react.default.createElement("span", {
        className: "body14-light tl-assistive-text",
        id: "".concat(this.props.id, "--help-text")
      }, assistiveText) : '', /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-text-input-wrapper"
      }, /*#__PURE__*/_react.default.createElement("input", _extends({
        className: inputClass,
        id: this.props.id,
        name: this.props.name,
        type: this.props.type ? this.props.type : "text",
        placeholder: this.props.placeholder || "",
        value: this.props.value,
        maxLength: this.props.maxLength,
        minLength: this.props.minLength,
        required: this.props.required,
        tabIndex: this.props.tabIndex,
        readOnly: this.props.readonly,
        onKeyPress: this.props.onKeyPress,
        onKeyUp: this.props.onKeyUp,
        onKeyDown: this.props.onKeyDown,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onChange: this.handleChange,
        onClick: this.props.onClick,
        autoFocus: this.props.autofocus,
        disabled: this.props.disabled,
        autoComplete: this.props.autoComplete,
        style: inputStyle
      }, customAriaAttributes)), variant !== 'advance' && (this.props.disabled || !this.props.label ? /*#__PURE__*/_react.default.createElement("div", {
        className: "label-disabled ".concat(labelUp)
      }, this.props.label) : /*#__PURE__*/_react.default.createElement("label", {
        id: labelId,
        className: labelUp,
        form: this.props.parent,
        htmlFor: this.props.id
      }, this.props.label)), this.props.variant === 'advance' ? /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-input-icon-container",
        style: {
          width: icons.length * baseIconWidth,
          height: baseIconWidth
        }
      }, icons) : icons));
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.wrapperClass ? this.props.wrapperClass.concat(" ", 'tl-text-input tl-ui') : 'tl-text-input tl-ui';
      className = className.concat(' ', "".concat(this.props.variant === 'advance' ? 'tl-input-wrapper-v1' : ''));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, this.renderInputBox(), this.getAssistiveText());
    }
  }]);
  return TextInput;
}(_react.default.Component);
exports.TextInput = TextInput;